
import { Component, Input, OnInit } from '@angular/core';
import { ModalController, AlertController, ToastController, ActionSheetController } from '@ionic/angular';
import { JavapiService } from '../../services/javapi.service';
import { MetodosgenService } from '../../services/metodosgen.service';
import { firstValueFrom } from 'rxjs';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

@Component({
  selector: 'app-item-details',
  templateUrl: './item-details.component.html',
  styleUrls: ['./item-details.component.scss'],
  standalone: false
})
export class ItemDetailsComponent implements OnInit {

  @Input() trabajoItem: any;
  @Input() trabajoId: any;

  segment: string = 'GENERAL'; // GENERAL, ANTES, DESPUES

  details: any[] = [];
  filteredDetails: any[] = [];

  constructor(
    private modalCtrl: ModalController,
    public javapiService: JavapiService,
    private metodosGenService: MetodosgenService,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private actionSheetCtrl: ActionSheetController
  ) { }

  ngOnInit() {
    this.loadDetails();
  }

  async loadDetails() {
    try {
      const payload = this.metodosGenService.setModeloGeneral(
        "genModel", "itemDetails",
        String(this.trabajoItem.id), "", "", "", "", "", "", "", "", "", "", "", "", "", ""
      );

      // Let's temporarily block this and fix the GET retrieval strategy.
      // For now, I'll write the logic assuming we have a way to get it, usually via `sp_requests_gen`.

      // FIX STRATEGY: Add 'itemDetails' subrutina to `sp_requests_gen`.
      // Then call it here.

      const res: any = await firstValueFrom(
        this.javapiService.getCommonModel(
          this.metodosGenService.setModeloGeneral(
            "genModel", "itemDetails", String(this.trabajoItem.id), "", "", "", "", "", "", "", "", "", "", "", "", "", ""
          )
        )
      );

      if (Array.isArray(res)) {
        this.details = res.map(d => ({
          id: d.dt1,
          tipo: d.dt2,
          clasificacion: d.dt3,
          imagen_path: d.dt4, // Filename
          texto: d.dt5,
          fecha: d.dt6
        }));
        this.filterDetails();
      }

    } catch (error) {
      console.error("Error loading details", error);
    }
  }

  filterDetails() {
    this.filteredDetails = this.details.filter(d => d.clasificacion === this.segment);
  }

  segmentChanged(ev: any) {
    this.segment = ev.detail.value;
    this.filterDetails();
  }

  close() {
    this.modalCtrl.dismiss();
  }

  async addNote() {
    const alert = await this.alertCtrl.create({
      header: 'Nueva Nota (' + this.segment + ')',
      cssClass: 'custom-alert',
      inputs: [
        {
          name: 'nota',
          type: 'textarea',
          placeholder: 'Escribe tu nota aquí...'
        }
      ],
      buttons: [
        { text: 'Cancelar', role: 'cancel', cssClass: 'alert-button' },
        {
          text: 'Guardar',
          cssClass: 'alert-button',
          handler: (data) => {
            if (data.nota) this.saveDetail('NOTA', data.nota, '');
          }
        }
      ]
    });
    await alert.present();
  }

  async addPhoto() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Seleccionar Imagen',
      buttons: [
        {
          text: 'Cámara',
          icon: 'camera',
          handler: () => this.takePhoto(CameraSource.Camera)
        },
        {
          text: 'Galería',
          icon: 'image',
          handler: () => this.takePhoto(CameraSource.Photos)
        },
        { text: 'Cancelar', role: 'cancel', icon: 'close' }
      ]
    });
    await actionSheet.present();
  }

  async takePhoto(source: CameraSource) {
    try {
      const image = await Camera.getPhoto({
        quality: 80,
        allowEditing: false,
        resultType: CameraResultType.Base64,
        source: source
      });

      if (image.base64String) {
        // Ask for caption?
        this.askForCaption(image.base64String);
      }
    } catch (e) {
      console.error("User cancelled or error", e);
    }
  }

  async askForCaption(base64: string) {
    const alert = await this.alertCtrl.create({
      header: 'Descripción de la Foto',
      cssClass: 'custom-alert',
      inputs: [
        {
          name: 'caption',
          type: 'text',
          placeholder: 'Opcional...'
        }
      ],
      buttons: [
        {
          text: 'Guardar sin texto',
          cssClass: 'alert-button',
          handler: () => this.saveDetail('IMAGEN', '', base64)
        },
        {
          text: 'Guardar',
          cssClass: 'alert-button',
          handler: (data) => this.saveDetail('IMAGEN', data.caption || '', base64)
        }
      ]
    });
    await alert.present();
  }

  async saveDetail(tipo: string, texto: string, imagen: string) {
    try {
      // Endpoint: /presupuesto/save/itemDetalle
      // dt1=id(0), dt2=trabajo_item_id, dt3=tipo, dt4=clasificacion, dt5=imagen, dt6=texto

      const payload = this.metodosGenService.setModeloGeneral(
        "ITEM_DETALLES", "INSERT",
        "0", String(this.trabajoItem.id),
        tipo, this.segment, imagen, texto,
        "", "", "", "", "", "", "", "", ""
      );

      // We need to call the NEW endpoint saveTrabajoItemDetalle
      // But javapiService might not have it exposed yet.
      // We will assume we added it or use a generic POST if available.
      // Let's look at available methods. `savePresupuesto` is widely used.
      // We should probably add `saveItemDetail` to `javapi.service.ts`.

      // Temporary hack: use savePresupuestoDetalle if it allows routing? No, different URL.
      // So I will need to update JavapiService. For now, assume it exists as `saveTrabajoItemDetalle`.

      const res: any = await firstValueFrom(this.javapiService.saveTrabajoItemDetalle(payload));

      if (res && res.success) {
        this.toastCtrl.create({ message: 'Guardado', duration: 2000, color: 'success' }).then(t => t.present());
        this.loadDetails();
      } else {
        this.toastCtrl.create({ message: 'Error al guardar', duration: 2000, color: 'danger' }).then(t => t.present());
      }

    } catch (error) {
      console.error("Error saving", error);
      this.toastCtrl.create({ message: 'Error de conexión', duration: 2000, color: 'danger' }).then(t => t.present());
    }
  }
}
